export default __webpack_public_path__ + "static/chat-light-7dfdccbc35af0b74afbc3e2743aaf137e7ffda201205913f9474f2e096167814.png";